import Case from '@/entities/case/case';

export default {
  case: new Case(),
  cases: []
};



// WEBPACK FOOTER //
// src/store/modules/cases/state.js